<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="sysUserNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('加盟商/物业.加盟商/物业系统编号')}}<template slot="title">{{$t('加盟商/物业.加盟商/物业系统编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sysUserNo" :maxLength="40" :placeholder="$t('通用.输入.请输入')+$t('加盟商/物业.加盟商/物业系统编号')" />
      </a-form-model-item>
      <a-form-model-item prop="pSysUserNo" >
        <span slot="label" >
          <a-tooltip>
            {{$t('加盟商/物业.物业的所属的加盟商编号')}}<template slot="title">{{$t('加盟商/物业.物业的所属的加盟商编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.pSysUserNo" :maxLength="40" :placeholder="$t('通用.输入.请输入')+$t('加盟商/物业.物业的所属的加盟商编号')" />
      </a-form-model-item>
      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('加盟商/物业.余额')}}<template slot="title">{{$t('加盟商/物业.余额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money"  :placeholder="$t('通用.输入.请输入')+$t('加盟商/物业.余额')" />
      </a-form-model-item>
      <a-form-model-item prop="allMoney" >
        <span slot="label" >
          <a-tooltip>
            {{$t('加盟商/物业.总收入金额')}}<template slot="title">{{$t('加盟商/物业.总收入金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.allMoney"  :placeholder="$t('通用.输入.请输入')+$t('加盟商/物业.总收入金额')" />
      </a-form-model-item>
      <a-form-model-item prop="roleId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('加盟商/物业.角色id')}}<template slot="title">{{$t('加盟商/物业.角色id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.roleId"  :placeholder="$t('通用.输入.请输入')+$t('加盟商/物业.角色id')" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPropertyUser, addPropertyUser, updatePropertyUser } from '@/api/franchisee/propertyUser'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        sysUserNo: null,

        pSysUserNo: null,

        money: null,

        allMoney: null,

        roleId: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        sysUserNo: null,
        pSysUserNo: null,
        money: null,
        allMoney: null,
        roleId: null,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPropertyUser({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updatePropertyUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addPropertyUser(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
